module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-bar com-model m-b-15"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/home'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/home/notice'
      }
    }
  }, [_vm._v("公告通知")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("公告详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-cont com-model"
  }, [_c('div', {
    staticClass: "notice-title"
  }, [_vm._v(_vm._s(_vm.notice.title))]), _vm._v(" "), _c('div', {
    staticClass: "flex m-b-24"
  }, [_c('div', [_c('div', {
    staticClass: "pub-name"
  }, [_vm._v(_vm._s(_vm.notice.publishUsername))]), _vm._v(" "), _c('div', {
    staticClass: "pub-time"
  }, [_vm._v(_vm._s(_vm.notice.createdAt))])])]), _vm._v(" "), _c('div', {
    staticClass: "notice-content"
  }, [_vm._v(_vm._s(_vm.notice.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f303f5d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/notice/detail.vue
// module id = 899
// module chunks = 1